var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loadingSpinner"},[_c('div',{staticClass:"loadingSpinner__cube"}),_vm._v(" "),_c('div',{staticClass:"loadingSpinner__text"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n    "),_c('span',[_vm._v(".")]),_vm._v(" "),_c('span',[_vm._v(".")]),_vm._v(" "),_c('span',[_vm._v(".")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b45fe31c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Spinner.vue
// module id = 94
// module chunks = 0